import * as React from "react";
import type { SVGProps } from "react";
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#mail_svg__a)">
      <path d="M19 20H5c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h14c1.65 0 3 1.35 3 3v10c0 1.65-1.35 3-3 3M5 6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z" />
      <path d="M12 14c-.24 0-.47-.08-.66-.25l-8-7c-.42-.36-.46-1-.09-1.41.36-.42 1-.46 1.41-.09L12 11.67l7.34-6.42c.41-.36 1.04-.32 1.41.09.36.42.32 1.05-.09 1.41l-8 7c-.19.17-.42.25-.66.25" />
    </g>
    <defs>
      <clipPath id="mail_svg__a">
        <path fill="#fff" d="M2 4h20v16H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMail;
